import { uri } from '../utils/config';
import { HTTP } from './secure/http';
import config from '../utils/config';

export const getActiveMenu = async (placeId) => {
  if (!placeId) {
    console.log('NO PLACE ID ACTIVE MENU');
    return;
  }

  let data = null;
  try {
    const response = await HTTP.get({
      path: `${uri.api}/place/${placeId}`,
    });
    data = response.data;
  } catch (error) {
    console.log('ERROR', error)
  }

  if (!data) {
    console.log('DATA UNAVAILABLE MENU');
    return {
      error: true,
    };
  }

  const { place, productId__product, toppingId__topping, categoryId__category, toppingGroupId__toppingsGroups, serviceId__service, userId__user } = data;
  if (!place || !productId__product || !toppingId__topping || !categoryId__category || !toppingGroupId__toppingsGroups || !serviceId__service) {
    console.log('DATA PARTIALY AVAILABLE');
    return {
      error: true,
    };
  }

  const indexCategories = {
    name__category: {},
    names: [],
    categoryId__productsId: {},
    productId_categoryNames: {},
    group__categoryIds: {},
  };

  const indexProducts = {
    name__product: {},
    names: [],
  };

  const categoryId__products = {};
  const gorupCategoryId__categories = {};
  const categoryId_extraProducts = {};

  for (const categoryId in categoryId__category) {
    const category = categoryId__category[categoryId];

    if (category.nested) {
      if (gorupCategoryId__categories[category.nested]) {
        gorupCategoryId__categories[category.nested].push(category)
      } else {
        gorupCategoryId__categories[category.nested] = [category]
      }
    }
    indexCategories.name__category[category.name.toLowerCase()] = category;
  }

  for (const productId in productId__product) {
    const product = productId__product[productId];
    if (product.extra_cat && product.extra_cat.length > 0) {
      for (const extraCat of product.extra_cat) {
        if (categoryId_extraProducts[extraCat]) {
          categoryId_extraProducts[extraCat].push(product);
        } else {
          categoryId_extraProducts[extraCat] = [product];
        }
      }
    }
    indexProducts.name__product[product.name.toLowerCase()] = product;
    const categoryNames = [];
    if (categoryId__category[product.category_id]) {
      if (product.extra_cat && Array.isArray(product.extra_cat)) {
        for (const extraCat of product.extra_cat) {
          if (categoryId__category[extraCat]) {
            categoryNames.push(categoryId__category[extraCat].name)
          }
        }
      }
    }
    indexCategories.productId_categoryNames[productId] = categoryNames;
    if (categoryId__products[product.category_id]) {
      categoryId__products[product.category_id].push(product)
    } else {
      categoryId__products[product.category_id] = [product]
    }

    if (indexCategories.categoryId__productsId[product.category_id]) {
      indexCategories.categoryId__productsId[product.category_id].push(productId)
    } else {
      indexCategories.categoryId__productsId[product.category_id] = [productId]
    }
  }

  const group__categoryIds = {};
  for (const categoryId in categoryId__category) {
    if (!categoryId__category[categoryId].nested) continue;
    const products = indexCategories.categoryId__productsId[categoryId]
      ? indexCategories.categoryId__productsId[categoryId]
      : [];
    if (group__categoryIds[categoryId__category[categoryId].nested]) {
      group__categoryIds[categoryId__category[categoryId].nested].push(...products);
    } else {
      group__categoryIds[categoryId__category[categoryId].nested] = [...products];
    }
  }

  indexCategories.group__categoryIds = group__categoryIds;

  const productsWithImages = {};

  for (const categoryId in categoryId__category) {
    const category = categoryId__category[categoryId];
    const isGroupCategory = category.group;

    const categoryProducts = isGroupCategory ? indexCategories.group__categoryIds[categoryId] : indexCategories.categoryId__productsId[categoryId];
    if (!productsWithImages[category.service_id]) {
      productsWithImages[category.service_id] = [];
    }
    if (categoryProducts && categoryProducts.length > 0) {
      const productsWithImagesOnly = categoryProducts.filter((productId) => productId__product[productId].has_image && productId__product[productId].promote === true);
      productsWithImages[category.service_id].push(...productsWithImagesOnly);
      const productId = productsWithImagesOnly[Math.floor(Math.random() * productsWithImagesOnly.length)]
      category.randomImageFromProducts = `${config.uri.bucket}/${placeId}/low/${productId}.jpg?time=${new Date().getTime()}`;
    }

    if (category.has_image) {
      category.image = `${config.uri.bucket}/${placeId}/low/${categoryId}.jpg?time=${new Date().getTime()}`
    } else if (!category.randomImageFromProducts) {
      category.image = null;
      category.randomImageFromProducts = null;
    }
  }

  const indexToppings = {
    name__toppingGroup: {},
    name__topping: {},
    namesToppings: [],
    namesToppingsGroups: [],
    toppingGroupId__toppings: {},
    toppingId_toppingGroupName: {},
  };

  for (const toppingGroupId in toppingGroupId__toppingsGroups) {
    const toppingGroup = toppingGroupId__toppingsGroups[toppingGroupId];
    indexToppings.name__toppingGroup[toppingGroup.name.toLowerCase()] = toppingGroup;
  }

  for (const toppingId in toppingId__topping) {
    const topping = toppingId__topping[toppingId];
    const toppingGroupId = topping.toppings_group_id;
    indexToppings.name__topping[topping.name.toLowerCase()] = topping;
    if (!indexToppings.toppingGroupId__toppings[toppingGroupId]) {
      indexToppings.toppingGroupId__toppings[toppingGroupId] = [];
    }
    topping && (indexToppings.toppingGroupId__toppings[toppingGroupId][topping.position - 1] = topping);
  }

  const indexServices = {
    name__service: {},
    namesServices: [],
  };

  for (const serviceId in serviceId__service) {
    const service = serviceId__service[serviceId];
    if (service.has_image) {
      service.image = `${config.uri.bucket}/${placeId}/low/${service.id}.jpg?time=${new Date().getTime()}`;
    }
    if (productsWithImages[serviceId] && productsWithImages[serviceId].length > 0) {
      const productId = productsWithImages[serviceId][Math.floor(Math.random() * productsWithImages[serviceId].length)]
      service.randomImageFromProducts = `${config.uri.bucket}/${placeId}/low/${productId}.jpg?time=${new Date().getTime()}`;
    } else {
      service.randomImageFromProducts = null;
    }
    indexServices.name__service[service.name.toLowerCase()] = service;
  }

  indexProducts.names = Object.keys(indexProducts.name__product);

  indexCategories.names = Object.keys(indexCategories.name__category);

  indexToppings.namesToppings = Object.keys(indexToppings.name__topping);

  indexServices.namesServices = Object.keys(indexServices.name__service);

  indexToppings.namesToppingsGroups = Object.keys(indexToppings.name__toppingGroup);

  const newProduct = {
    category_id: undefined,
    code: '',
    consumers: '',
    contents: [],
    cost: '1',
    created_at: new Date().toISOString(),
    active: true,
    deleted: false,
    delivery: false,
    details: '',
    extra_cat: null,
    has_image: false,
    has_movie: false,
    id: 'new',
    name: '',
    place_id: placeId,
    promote: true,
    tags: [],
    toppings_group_id: null,
    updated_at: new Date().toISOString(),
    weight: '',
    external_link: '',
  }
  productId__product.new = newProduct;

  const newCategory = {
    id: 'new',
    name: '',
    code: '',
    has_image: false,
    showable: true,
    top: false,
    nested: null,
    group: false,
    active: true,
    deleted: false,
  }

  const newService = {
    id: 'new',
    name: '',
    has_image: false,
    description: '',
    active: true,
    deleted: false,
  }

  categoryId__category.new = newCategory;
  serviceId__service.new = newService;

  if (!place?.features) {
    place.features = {}
  }

  const placeData = {
    initialized: true,
    place,
    users: { userId__user },
    products: { productId__product, index: indexProducts },
    toppings: { toppingId__topping, toppingGroupId__toppingsGroups, indexToppings },
    services: { serviceId__service, indexServices },
    categories: { categoryId__products, categoryId__category, index: indexCategories, gorupCategoryId__categories, categoryId_extraProducts },
    initialized: true,
    loading: false,
  };

  return placeData;
};